import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HelpDropdown } from "../Common/HelpDropdown";
import "./Header.css";

const NAV_LINKS: { to: string; label: string; ariaLabel: string; accent?: boolean }[] = [
	{ to: "/issuer", label: "Issuers", ariaLabel: "For Issuers" },
	{
		to: "/graduation",
		label: "Credential Holders",
		ariaLabel: "For Credential Holders",
	},
	{ to: "/verifier", label: "Verifiers", ariaLabel: "For Verifiers" },
	{ to: "/publication", label: "Publication", ariaLabel: "Publication" },
	{ to: "/event", label: "Event", ariaLabel: "Event", accent: true },
];

export const Header: React.FC = () => {
	const [helpOpen, setHelpOpen] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);
	const location = useLocation();

	const isActive = (to: string) =>
		to === "/"
			? location.pathname === "/"
			: location.pathname.startsWith(to);

	const handleMenuToggle = () => {
		setMenuOpen((prev) => !prev);
		setHelpOpen(false);
	};

	return (
		<header className="vt-header" aria-label="Site header">
			<div className="vt-header-inner-inner">
				<div className="vt-header-row">
					<div className="vt-header-left">
						<div className="vt-logo" aria-label="VerifyTT logo">
							<Link to="/">
								<img
									alt="logo"
									src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/logo.svg"
								/>
							</Link>
						</div>
					</div>

					<div className="vt-header-center">
						<nav
							className="vt-nav-desktop"
							aria-label="Primary navigation"
						>
							{NAV_LINKS.map(({ to, label, ariaLabel, accent }) => (
								<div className="vt-nav-item" key={to}>
									<div className="vt-nav-item-inner">
										<Link
											to={to}
											className={`vt-nav-link${accent ? " vt-nav-link-accent" : ""}`}
											aria-label={ariaLabel}
										>
											<div
												className={`vt-nav-text${isActive(to) ? " vt-nav-text-active" : ""}`}
											>
												{label}
											</div>
										</Link>
									</div>
								</div>
							))}
						</nav>
					</div>

					<div className="vt-header-right">
						<HelpDropdown
							helpOpen={helpOpen}
							setHelpOpen={setHelpOpen}
							menuOpen={menuOpen}
							setMenuOpen={setMenuOpen}
						/>

						<button
							type="button"
							className={`vt-menu-toggle${menuOpen ? " open" : ""}`}
							onClick={handleMenuToggle}
							aria-label="Toggle navigation"
							aria-expanded={menuOpen}
							aria-controls="vtNavDropdown"
						>
							<div className="vt-menu-toggle-line" />
						</button>
					</div>

					<div
						className={`vt-nav-dropdown${menuOpen ? " open" : ""}`}
						id="vtNavDropdown"
						aria-label="Mobile navigation"
					>
						{NAV_LINKS.map(({ to, label, ariaLabel }) => (
							<div className="vt-nav-dropdown-item" key={to}>
								<Link
									to={to}
									className="vt-nav-dropdown-link"
									role="menuitem"
									aria-label={ariaLabel}
									aria-current={
										isActive(to) ? "page" : undefined
									}
									onClick={() => setMenuOpen(false)}
								>
									<span
										className={`vt-nav-dropdown-text${isActive(to) ? " vt-nav-dropdown-text-active" : ""}`}
									>
										{label}
									</span>
								</Link>
							</div>
						))}
					</div>
				</div>
			</div>
		</header>
	);
};
